import { useTranslation } from 'next-i18next'
import { LanguageSwitcher } from '../language-switcher'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import useAuth from '@/contexts/useAuth'
import { formatName } from '@/helper/formatter'
import { Button } from '../ui/button'
import { SidebarTrigger } from '../ui/sidebar'

export function Navigation() {
  const { t } = useTranslation('common')
  const { user, logout } = useAuth()

  return (
    <header className="flex h-[60px] min-h-[60px] items-center justify-between w-full text-sm border-b-gray-100 border-b">
      <div className="h-full flex items-center">
        <SidebarTrigger />
      </div>
      <div className="flex items-center gap-2  mr-4">
        <div className="flex items-center gap-2">
          {user?.company?.name}

          <LanguageSwitcher />

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="">
                <div className="text-left">
                  <div className="leading-none text-xs">
                    {formatName(user as any)}
                  </div>
                  <span className="text-xs text-stone-500 leading-none capitalize">
                    {user?.role}
                  </span>
                </div>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              side="top"
              className="w-[--radix-popper-anchor-width]"
            >
              {/* <DropdownMenuItem>
                <span>{t('account')}</span>
              </DropdownMenuItem> */}
              <DropdownMenuItem onClick={logout}>
                <button className="block w-full text-left">
                  {t('logout')}
                </button>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  )
}
